import { Button, Card, Col, Modal, Row, Table } from "antd";
import { useVisorMartillo } from "hooks/productos/useVisorMartillo";
import { useVT } from "virtualizedtableforantd4";
import "./VisorMartillo.css";
import MargenUltimoTrimestre from "./visormartillo/MargenUltimoTrimestre";
import PorcentajeProductos from "./visormartillo/PorcentajeProductos";
import Iqvia from "./visormartillo/Iqvia";
import TipoPromo from "./visormartillo/TipoPromo";
import UltimasComprasTable from "./visormartillo/UltimasComprasTable";
import DescuentoDiaTable from "./visormartillo/DescuentoDiaTable";
import UltimosPedidosTable from "./visormartillo/UltimosPedidosTable";
import PromocionesMF from "./visormartillo/PromocionesMF";
import PromocionesProveedor from "./visormartillo/PromocionesProveedor";
import GenerarOrden from "components/compras/GenerarOrden";
import OrdenCompraEdit from "components/compras/OrdenCompraEdit";
import StockFarmaciasTable from "./visormartillo/StockFarmaciasTable";
import { SaveOutlined } from "@ant-design/icons";

const VisorMartillo = () => {
  const {
    datosBodega,
    vtRef,
    columns,
    onRowClick,
    columnsBodega,
    rowSelection,
    tableRef,
    loader,
    dataIqvia,
    ultimasCompras,
    descuentosDias,
    ultimosPedidos,
    promo,
    esPromo,
    margenes,
    showModalGenOrden,
    setshowModalGenOrden,
    dataProductosOrden,
    setdataProductosOrden,
    handleChange,
    sortedData,
    promoProveedor,
    getDataBodega,
    setLoader,
    showModalStockFarmacias,
    setshowModalStockFarmacias,
    getStockBodegas,
    selectedRowKeys,
    datosStockBodegas,
    loaderStock,
    nameProduct,
    namePharma,
    //rowSelectionProveedor,
    //OnChangeSelectionProveedor,
    setselectkeyProveedor,
    handleSendTableCompras,
    selectkeyProveedor,
    SumProveedorOrdenCompra,
    ordenesCompra,
    ColumnsOrden,
    loaderBtnCompra,
  } = useVisorMartillo();

  const [vt] = useVT(() => ({ scroll: { y: "59vh" }, ref: vtRef /*, overscanRowCount: 20 */ }), []);

  return (
    <div style={{ position: "relative" }}>
      {dataProductosOrden.length > 0 && (
        <Button
          type='primary'
          size='small'
          loading={loaderBtnCompra}
          style={{
            position: "absolute",
            top: -23,
            // right: 145, // margen derecho
            right: 10,
            zIndex: 10,
            fontSize: "11px",
            height: "20px",
            backgroundColor: "green",
          }}
          icon={<SaveOutlined />}
          onClick={handleSendTableCompras}
        >
          Guardar
        </Button>
      )}
      {dataProductosOrden.length <= 0 && (
        <Button
          type='primary'
          size='small'
          style={{
            position: "absolute",
            top: -23,
            right: 10, // margen derecho
            zIndex: 10,
            fontSize: "11px",
            height: "20px",
          }}
          onClick={() => setshowModalGenOrden(true)}
        >
          Sugerido de Compras
        </Button>
      )}
      <Card
        className='card-small'
        style={{
          // overflowY: "hidden",
          // overflowX: "hidden",
          padding: "2px",
          // height: "calc(100vh - 89px)",
        }}
      >
        {/* <Row> */}
        {dataProductosOrden.length > 0 && (
          <Row>
            <Col xs={24} style={{ marginBottom: "0px" }}>
              <OrdenCompraEdit
                dataProductosOrden={dataProductosOrden}
                setdataProductosOrden={setdataProductosOrden}
                getDataBodega={getDataBodega}
                setLoader={setLoader}
                OnChangeSelectionProveedor={setselectkeyProveedor}
                SumProveedorOrdenCompra={SumProveedorOrdenCompra}
              />
            </Col>
          </Row>
        )}
        <Row>
          {dataProductosOrden.length <= 0 && (
            <Col xs={24} style={{ marginBottom: "2px" }}>
              <Table
                ref={tableRef}
                components={vt}
                pagination={false}
                columns={columns}
                scroll={{ x: 900, y: "49vh" }}
                size='small'
                dataSource={sortedData ? sortedData : []}
                bordered
                rowSelection={rowSelection}
                onRow={onRowClick}
                className='custom-table-visor'
                onChange={handleChange}
              />
            </Col>
          )}
        </Row>

        <Row>
          <Col xs={2}>
            <DescuentoDiaTable data={descuentosDias} loading={loader}></DescuentoDiaTable>
          </Col>
          <Col xs={4}>
            <Row gutter={[0, 5]}>
              <Col xs={24}>
                <PromocionesMF promo={promo}></PromocionesMF>
              </Col>
              <Col xs={24}>
                <UltimosPedidosTable data={ultimosPedidos} loading={loader}></UltimosPedidosTable>
              </Col>
            </Row>
          </Col>
          <Col xs={9}>
            <Row gutter={[5, 5]}>
              <Col xs={17}>
                <UltimasComprasTable UltimaCompra={ultimasCompras} loader={loader}></UltimasComprasTable>
              </Col>
              <Col xs={7}>
                <Table
                  scroll={{ y: 50 }}
                  title={() => (
                    <div style={{ textAlign: "left" }}>Ordenes de Compras {"  (" + ordenesCompra.length + ")"}</div>
                  )}
                  className='custom-table-visor'
                  columns={ColumnsOrden}
                  dataSource={ordenesCompra}
                  style={{ fontSize: "6px" }}
                  pagination={false}
                ></Table>
              </Col>
            </Row>
            <Row gutter={[5, 5]}>
              <Col xs={24}>
                <PromocionesProveedor
                  data={promoProveedor}
                  loading={loader}
                  selectkeyProveedorinit={selectkeyProveedor ? selectkeyProveedor : 0}
                  setselectkeyProveedor={setselectkeyProveedor}
                  dataProductosOrden={dataProductosOrden}
                  setdataProductosOrden={setdataProductosOrden}
                ></PromocionesProveedor>
              </Col>
            </Row>
          </Col>
          <Col xs={9}>
            <Row gutter={[5, 5]}>
              <Col xs={24}>
                <Table
                  className='custom-table-visor'
                  pagination={false}
                  columns={columnsBodega}
                  scroll={{ x: 100, y: 75 }}
                  // scroll={{ x: 900, y: 150 }}
                  size='small'
                  bordered
                  loading={loader}
                  dataSource={datosBodega ? datosBodega : []}
                  onRow={(record) => {
                    const keysConHover = ["FARMACIAS SG", "FARMACIAS MIA"];
                    if (keysConHover.includes(record.Bodega)) {
                      return {
                        onClick: () => {
                          getStockBodegas(selectedRowKeys[0], record.key);
                        },
                        className: "fila-hover",
                      };
                    }
                    return {};
                  }}
                />
              </Col>

              <Col xs={24}>
                <Iqvia dataIqvia={dataIqvia} loader={loader} />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={[5, 5]}>
          <Col xs={12}>
            <Row justify='start' align='top' gutter={0} wrap={false}>
              <Col xs={12}>
                <MargenUltimoTrimestre margenes={margenes} />
              </Col>
              <Col xs={12}>
                <PorcentajeProductos />
              </Col>
            </Row>
          </Col>
          <Col xs={12} style={{ marginTop: "15px" }}>
            <TipoPromo esPromo={esPromo} />
          </Col>
        </Row>
        {/* </Row> */}
      </Card>

      <Modal
        title='Generar Orden de Compras'
        open={showModalGenOrden}
        onOk={() => setshowModalGenOrden(false)}
        onCancel={() => setshowModalGenOrden(false)}
        width={1000}
        bodyStyle={{ margin: 0, padding: "0px" }}
        footer={""}
        transitionName=''
      >
        <GenerarOrden
          setOpenModalGen={setshowModalGenOrden}
          setdataProductosOrden={setdataProductosOrden}
          SumProveedorOrdenCompra={SumProveedorOrdenCompra}
        />
      </Modal>

      {
        <Modal
          title={`${namePharma} - ${nameProduct}`}
          open={showModalStockFarmacias}
          onOk={() => setshowModalStockFarmacias(false)}
          onCancel={() => setshowModalStockFarmacias(false)}
          width={1100}
          footer={null}
          transitionName=''
        >
          {showModalStockFarmacias && (
            <StockFarmaciasTable dataStock={datosStockBodegas} loader={loaderStock}></StockFarmaciasTable>
          )}
        </Modal>
      }
    </div>
  );
};

export default VisorMartillo;
